import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const MediaGallery = () => {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Dynamically determine base URL
  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://joygardens-backend.onrender.com";

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/media`);
        setMedia(response.data.resources);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching media:', err);
        setError('Failed to load media. Please try again later.');
        setLoading(false);
      }
    };

    fetchMedia();
  }, [BASE_URL]);

  const handleDoubleClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-100 pt-24">
      <Navbar />
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-4xl font-bold text-blue-900 mb-6 text-center">Media Gallery</h1>
        {loading ? (
          <p className="text-center text-gray-700 text-lg">Loading...</p>
        ) : error ? (
          <p className="text-center text-red-600 text-lg">{error}</p>
        ) : media.length === 0 ? (
          <p className="text-center text-gray-700 text-lg">No media available at the moment.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {media.map((item) => (
              <div
                key={item.asset_id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow"
              >
                {item.resource_type === 'image' && (
                  <img
                    src={item.secure_url}
                    alt="Media"
                    className="w-full h-48 object-cover cursor-pointer"
                    onDoubleClick={() => handleDoubleClick(item.secure_url)}
                  />
                )}
                <p className="text-center text-sm text-gray-500 mt-2">
                  {new Date(item.created_at).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaGallery;
